import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { SiteAvatarComponent } from './site-avatar.component';

@NgModule({
  declarations: [
    SiteAvatarComponent
  ],
  imports: [
    CommonModule,
    InlineButtonModule,
    MatDialogModule,
    MatTooltipModule
  ],
  exports: [
    SiteAvatarComponent
  ]
})
export class SiteAvatarModule { }
